import { __ } from "@wordpress/i18n";
import { useRulesContext } from "../../../../../hook/useRulesContext";
import { Search, Plus, CircleAlert } from "lucide-react";

export default function EmptyState() {
    const { searchTerm, filterStatus, setShowAddModal } = useRulesContext();

    return (
        <div className="px-6 py-12 text-center">
            <div className="text-gray-400 mb-4">
                {searchTerm ? (
                    <Search className="w-12 h-12 mx-auto" />
                ) : (
                    <CircleAlert className="w-12 h-12 mx-auto" />
                )}
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">
                {{
                    trash: __(
                        "No Quantity Rules Found in Trash!",
                        "wpbean-quantity-controls-for-woocommerce",
                    ),
                    inactive: __(
                        "No Inactive Quantity Rules Found!",
                        "wpbean-quantity-controls-for-woocommerce",
                    ),
                }[filterStatus] ||
                    __(
                        "No Quantity Rules Found!",
                        "wpbean-quantity-controls-for-woocommerce",
                    )}
            </h3>
            <p className="text-gray-500 mb-4">
                {searchTerm
                    ? __(
                          "Try adjusting your search terms.",
                          "wpbean-quantity-controls-for-woocommerce",
                      )
                    : __(
                          "Get started by creating your first quantity rule.",
                          "wpbean-quantity-controls-for-woocommerce",
                      )}
            </p>
            {!searchTerm && !filterStatus && (
                <button
                    onClick={() => setShowAddModal(true)}
                    className="inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-colors"
                >
                    <Plus className="w-4 h-4 mr-2" />
                    {__("Add New", "wpbean-quantity-controls-for-woocommerce")}
                </button>
            )}
        </div>
    );
}
